module.exports = __webpack_public_path__ + "static/media/js.b9fbab6c.jpg";